import {Prompt} from '../../../utils/Interfaces/PromptGallery';
export const promptsData: Prompt[] = [
 
    // {
    //   id: '3',
    //   image: 'https://dlvkyia8i4zmz.cloudfront.net/am2PcJISKqG3QsiTlqIZ_ipreal.png',
    //   title: 'Whats my IP',
    //   description: 'Create a straightforward Whats My IP  website that displays the users public IP address. The site should also show basic information such as the city and country associated with the IP address. Ensure the design is clean and responsive for both desktop and mobile devices. Include a button for users to refresh their IP information easily.',
    //   type:'',
    // },
    // {
    //   id: '4',
    //   image: 'https://dlvkyia8i4zmz.cloudfront.net/jMGsnjqqSnOEjrLBDu6W_student.png',
    //   title: 'Website for School Student',
    //   description: 'Create an engaging landing page specifically designed for school students. The page should have a bright and colorful design that captures attention, featuring sections for important information like school announcements, upcoming events, and quick access to class schedules and study resources.',
    //   type:'',
    // },
    // {
    //   id: '5',
    //   image: 'https://dlvkyia8i4zmz.cloudfront.net/vujr2SfnRDuo1swlt13x_socialmedia.png',
    //   title: 'Social media application',
    //   description: 'Create a straightforward landing page for a social media application. The page should feature a clean design with essential information about the app. Highlight key features such as user profiles, news feeds, and messaging with simple graphics.',
    //   type:'',
    // },
    // {
    //   id: '6',
    //   image: 'https://dlvkyia8i4zmz.cloudfront.net/0z0K6cJjQsWKRy6V7DBf_stock.png',
    //   title: 'Stock website',
    //   description: 'Create a simple stock market website that displays real-time stock data and market news. The site should have an easy-to-navigate design, allowing users to search for stocks and view detailed quotes.Include basic charts to show stock performance and a section for the latest market updates. Ensure the website is responsive and works well on both mobile and desktop devices.',
    //   type:'',
    // },
    // {
    //   id: '7',
    //   image: 'https://dlvkyia8i4zmz.cloudfront.net/ItQcAtBxRY2E0TFM2Mrb_ordersite.png',
    //   title: 'Attendance order Site',
    //   description: 'Create a straightforward attendance order website for schools or organizations. The site should allow administrators to easily input and manage attendance records. Users should be able to view their attendance status and receive notifications for any updates.Include features for generating attendance reports and filtering data by date or event. Ensure the design is clean and responsive, providing a user-friendly experience on both mobile and desktop devices.',
    //   type:'',
    // },
      // {
    //   id: '10',
    //   image: 'https://dlvkyia8i4zmz.cloudfront.net/ItQcAtBxRY2E0TFM2Mrb_ordersite.png',
    //   title: 'QR Code Scanner',
    //   description: 'Scan QR codes effortlessly for quick access to links and information.',
    //   type:'General',
    // },
    {
      id: '1',
      image: 'https://dlvkyia8i4zmz.cloudfront.net/NSnQvo5NR1Gk8SXJ5nmw_image_42.png',
      title: 'Password Strength Analyzer',
      description: 'Create a password strength analyzer that evaluates passwords based on length, complexity, common patterns, and known breaches. Provide real-time feedback with a strength meter and specific suggestions for improvement.',
      type: 'General',
    },
    {
      id: '2',
      image: 'https://dlvkyia8i4zmz.cloudfront.net/4d6RT3fCRN2ZOnnfiqYj_image__1_.png',
      title: 'Mortgage Calculator',
      description: 'Build a mortgage calculator that computes monthly payments, total interest, and amortization schedule based on loan amount, interest rate, term, and down payment. Include visual charts showing payment breakdown.',
      type: 'calculator',
    },
    {
      id: '3',
      image: 'https://dlvkyia8i4zmz.cloudfront.net/GEHAVPmzQfCcOH9oliYa_image__2_.png',
      title: 'Weather App',
      description: 'Create a weather application that allows users to enter a city name and fetch real-time weather data using the Weather API. The app should feature a search input field where users can type the city name and a "Get Weather" button to fetch the data. Upon submission, it should display the city current weather details, including temperature (with a toggle between °C and °F), weather condition (such as sunny or cloudy), humidity, wind speed, and an appropriate weather icon',
      type: 'API',
    },
    // {
    //   id: '4',
    //   image: 'https://dlvkyia8i4zmz.cloudfront.net/ItQcAtBxRY2E0TFM2Mrb_ordersite.png',
    //   title: 'Image Background Remover',
    //   description: 'Develop an AI-powered tool that automatically removes backgrounds from uploaded images. Provide options for fine-tuning and different output formats.',
    //   type: 'AI',
    // },
    {
      id: '5',
      image: 'https://dlvkyia8i4zmz.cloudfront.net/zJI7kv4SsW4LL7ANUhB9_image__3_.png',
      title: 'Currency Converter',
      description: 'Build a real-time currency converter using exchange rate APIs. Include support for multiple currencies, conversion history, and rate trend charts. Implement a user-friendly interface with real-time updates for seamless conversions',
      type: 'API',
    },
    {
      id: '6',
      image: 'https://dlvkyia8i4zmz.cloudfront.net/gb8hNZ7zSB2JgiAWKVib_qrcodereal.png',
      title: 'QR Code Generator',
      description: 'Create a QR code generator that allows users to input text/URLs and customize colors and size. Include a "Generate" button, and it can have multiple download formats (PNG, JPEG). ',
      type:'General',
    },
    {
      id: '7',
      image: 'https://dlvkyia8i4zmz.cloudfront.net/JKmd8rlR8SYojlkRbZFE_image__4_.png',
      title: 'Text Sentiment Analyzer',
      description: `Create an AI tool that analyze the emotional tone and sentiment of the provided text. Return:

      1. Overall sentiment (positive, negative, or neutral)
      2. Dominant emotions detected (joy, sadness, anger, fear, surprise)
      3. Confidence score (0-100%) for each emotion
      4. Key phrases that indicate the identified emotions
      5. Use chart to show emotion over time and words`,
      type: 'AI',
    },
    {
      id: '8',
      image: 'http://dlvkyia8i4zmz.cloudfront.net/WfWSfipNQfKexydOwIo6_image__5_.png',
      title: 'BMI Calculator',
      description: 'Design an intuitive and user-friendly BMI calculator that allows users to input height and weight. Accurately calculate and display the BMI score along with the corresponding health category (e.g., underweight, normal, overweight, obese). Provide an ideal weight range based on height and offer personalized health recommendations. Ensure a clean, responsive UI with real-time calculations and clear, easy-to-understand results for an optimal user experience',
      type: 'calculator',
    },
    {
      id: '9',
      image: 'https://dlvkyia8i4zmz.cloudfront.net/R364kX9RTuijngLfl5jZ_image__6_.png',
      title: 'Compound Interest Calculator',
      description: 'Create a Compound Interest Calculator with an intuitive, user-friendly interface that allows users to input the principal amount, interest rate, the number of times interest is compounded per year, and the time in years. The calculator should instantly calculate and display both the total amount after applying interest and the interest earned.',
      type:'Calculator',
    },
   
    
    {
      id: '10',
      image: 'https://dlvkyia8i4zmz.cloudfront.net/UffaJZGYSQWWek5z4lIP_image__7_.png',
      title: 'Clipboard Format Viewer',
      description: 'Create a Clipboard Format Analyzer tool that enables users to paste content and view a detailed list of clipboard formats along with in-depth metadata, including format name, ID, data size, MIME type, and content previews where possible. The tool should provide real-time updates as clipboard content changes and allow users to copy specific format data back to the clipboard. Additional features include a "Clear" button to reset the tool, and an option to export the format list and metadata as a CSV or JSON report. A history feature should allow users to compare multiple clipboard entries, ensuring comprehensive analysis.',
      type:'General',
    },
  
    {
      id: '11',
      image: 'https://dlvkyia8i4zmz.cloudfront.net/L3hK909mSJqBpFY8tTbk_image__8_.png',
      title: 'LLM Pricing Calculator',
      description: 'Create a pricing calculator for Large Language Model (LLM) usage. The tool should allow users to input text length (in tokens), select a specific model (e.g., GPT-4, Claude 3, Gemini), and display the estimated cost based on the model pricing per 1K tokens. Include support for different pricing tiers (prompt tokens vs. completion tokens) and provide a breakdown of total cost. Ensure real-time updates, user-friendly UI, and clear cost estimation',
      type:'Calculator',
    },
    
    {
      id: '12',
      image: 'https://dlvkyia8i4zmz.cloudfront.net/Qjtx3KGSmObTLYfEofiZ_image__9_.png',
      title: 'YouTube Video Metrics Checker',
      description: 'Create a tool called YouTube Video Metrics Checker that integrates with APIs like YouTube Data API to analyze video ads and posts. Allow users to link videos and fetch metrics like views, likes, comments, and watch time. Present data in a user-friendly with visualizations, analyzing content quality, engagement, and policy compliance. Provide actionable insights to improve performance, like optimizing content or addressing drop-offs. Generate downloadable, platform-specific performance reports with tailored recommendations.',
      type:'API',
    },
    // {
    //   id: '13',
    //   image: 'https://dlvkyia8i4zmz.cloudfront.net/LiJoho0PTRwSxnWhnIes_image__10_.png',
    //   title: 'Interior Design Inspiration Tool',
    //   description: 'Create a tool called Interior Design Inspiration Tool that lets users upload a photo of their room and provides personalized interior design recommendations. The tool should analyze the photo to detect features like wall color, furniture placement, and lighting etc. Based on this analysis, it should suggest suitable furniture, décor, color palettes, and layouts that enhance the rooms style. Include options to identify the current design style and offer recommendations that complement or transform it. Provide a visualization of the recommended changes applied to the room',
    //   type:'AI',
    // },
    {
      id: '14',
      image: 'https://dlvkyia8i4zmz.cloudfront.net/Q1HbhWCyQnCnAEJuF3MB_image__11_.png',
      title: 'Code Generator',
      description: 'Develop an intelligent code generation tool that dynamically creates accurate and optimized code based on user-provided text prompts. Support multiple programming languages like javascript and python. Ensure a clean, responsive UI with a seamless and intuitive user experience, featuring one-click copy and download options.',
      type: 'AI',
    },
    {
      id: '15',
      image: 'https://dlvkyia8i4zmz.cloudfront.net/8AEm6TuGuuo5IM0fllwd_image__12_.png',
      title: 'Recipe Nutritional Analyzer',
      description: 'Design an AI-powered tool that calculates and displays detailed nutrient information for recipes. The tool should allow users to input ingredients with quantities and leverage AI to intelligently recognize, analyze, and give precise nutritional data. Display key metrics such as calories, macronutrients (proteins, fats, carbohydrates), vitamins, and minerals for each recipe. Ensure an intuitive, responsive UI with real-time updates and ingredient recommendations.',
      type: 'AI',
    },
    {
      id: '16',
      image: 'https://dlvkyia8i4zmz.cloudfront.net/W0bc5VeuRr6nMXPGampQ_image__13_.png',
      title: 'Spin the Joke Wheel',
      description: 'Create a "Spin the Joke Wheel" tool that generates random jokes across various categories. Include a virtual spinning wheel with colorful segments, each representing a different joke type (e.g., puns, dad jokes, one-liners, knock-knock jokes). Allow users to spin the wheel, then display a randomly selected joke from the chosen category.',
      type:'General',
    },
    {
      id: '17',
      image: 'https://dlvkyia8i4zmz.cloudfront.net/ByPww9XJRPey2imiEtr0_2151459498_1.png',
      title: 'AI Chatbot',
      description: 'Create a user-friendly AI chatbot. Implement a clean design with a message display area  and an input field for user messages. AI response should be clearly visible. Make the Chatbot full width. And align all the button properly. Rounded corner border with box shadow and radius. User icons for user and chatbot to differentiate the message. Integrate the OpenAI API to power the chatbots responses, ensuring proper API key management and error handling. Include features such as message history, typing indicators, and the ability to clear the chat. Optimize the chatbot for mobile devices and desktop browsers, and implement basic conversation context retention for more natural interactions ',
      type:'AI',
    },
    {
      id: '18',
      image: 'https://dlvkyia8i4zmz.cloudfront.net/EMmJnV2R6Gdm9u7VFei6_Group_1321316841__4_.png',
      title: 'AI Text Summarizer',
      description: 'Create an AI-powered text summarization tool that can condense long articles, documents, or text passages into concise summaries. Include options for summary length, key points extraction, and different summarization styles (bullet points, paragraph, etc.). Add support for multiple languages and the ability to save summaries.',
      type: 'AI',
    },
    // {
    //   id: '17',
    //   image: 'https://dlvkyia8i4zmz.cloudfront.net/ItQcAtBxRY2E0TFM2Mrb_ordersite.png',
    //   title: 'Stock Market API Dashboard',
    //   description: 'Develop a dashboard that displays real-time stock market data using financial APIs. Show price charts, company info, and basic technical indicators.',
    //   type: 'API',
    // },
    // {
    //   id: '18',
    //   image: 'https://dlvkyia8i4zmz.cloudfront.net/ItQcAtBxRY2E0TFM2Mrb_ordersite.png',
    //   title: 'Image Style Transfer',
    //   description: 'Create an AI tool that applies artistic styles to uploaded photos. Include various preset styles and adjustment controls for effect intensity.',
    //   type: 'AI',
    // },
    {
      id: '19',
      image: 'https://dlvkyia8i4zmz.cloudfront.net/YF6a94qJS7iImiOG6Qh8_image__15_.png',
      title: 'Color Palette Generator',
      description: 'Build a tool that generates harmonious color palettes from images or base colors. Include options for different color harmony rules and export formats.',
      type: 'General',
    },
    {
      id: '20',
      image: 'https://dlvkyia8i4zmz.cloudfront.net/8NfwPxjQsCaQnx1HlsDk_image__16_.png',
      title: 'Timezone Converter',
      description: 'Create a timezone conversion tool that allows users to convert time between different timezones. The tool should feature an intuitive interface with input fields for selecting the source timezone, target timezone, and the date and time to convert. Include a "Convert" button that displays the converted time in a clear, readable format. Provide a dropdown or searchable list of all major timezones, and allow users to set their local timezone as default. Ensure the tool is responsive, visually appealing, and user-friendly, with accurate conversions accounting for daylight saving time adjustments.',
      type: 'General',
    },
    {
      id: '21',
      image: 'https://dlvkyia8i4zmz.cloudfront.net/yHsZNug6RA2BOTwLJ7lc_image__17_.png',
      title: 'Snake Game',
      description: 'Create a Snake Game with a clean and minimalistic design featuring a "Play" button to start the game, a score display showing the current score and high score at the top, and a grid-based game area where the snake moves and grows by collecting food. Add clearly visible borderlines around the game grid to denote the path and a boundary to indicate the edges where the snake cannot pass. Below the game area, include visible arrow key controls for interaction, while also supporting keyboard arrow key input. When the game ends, display a "Game Over!" message along with a "Play Again" button to restart the game. Ensure smooth gameplay, responsive controls, and an intuitive, visually appealing layout.',
      type: 'Game',
    },
    {
      id: '22',
      image: 'https://dlvkyia8i4zmz.cloudfront.net/nd6vPWjzRaSzW9BsrNzI_image__18_.png',
      title: 'Word Scramble Game',
      description: `Create a fun, engaging word scramble game for kids. 
      Use some emojis and animation to attract kids.
      Create a full page game with modern UI.
      Use custom CSS toast/popup which will attract kids.
      Features:
      Display a random scrambled word from a set of 30 words since start of game.
      Show one word at a time. On Submit show next scrambled word.
      Hint Button – Provides a clue (meaning, first letter, etc.).
      Show scramble words and Input box to enter words. Add next and finish button
      And game End Screen. Add more relevent fields to make it complete.`,
      type: 'Game',
    },
    {
      id: '23',
      image: 'https://dlvkyia8i4zmz.cloudfront.net/nWYHgBvdQHujpZGH9Xu9_image__19_.png',
      title: 'Tic Tac Toe',
      description: 'Create a Tic Tac Toe game with a clean and modern interface. Include a game board with a 3x3 grid where players can click to place their X or O. Feature a header displaying the current players turn and game status (win/draw). Add a score tracker showing wins for both Player X and Player O, along with draws. Include a "New Game" button to reset the board while keeping scores, and a "Reset Scores" button to start fresh. Implement winning line animations to highlight the winning combination, and add subtle hover effects on empty cells. For enhanced user experience, include move sound effects and victory/draw sound notifications. The game should be responsive, working well on both desktop and mobile devices, with clear visual feedback for game events.',
      type: 'Game',
    },
    {
      id: '24',
      image: 'https://dlvkyia8i4zmz.cloudfront.net/Gdjqy3eBSMCmNKSzFz1K_image__20_.png',
      title: 'Rock Paper Scissor',
      description: 'Develop a Rock, Paper, Scissors game where the player selects their choice, and the system randomly picks one. Display the result ("You Win," "You Lose," or "Its a Draw!") based on the choices. Keep a running score of wins, losses, and ties, and include a "Play Again" button to restart the game. Create this game UI considering for kids and use full-page',
      type: 'Game',
    },
    {
      id: '25',
      image: 'https://dlvkyia8i4zmz.cloudfront.net/u2eE3HRqSq3IElLZ93ug_2151877724_1__1_.png',
      title: 'Prompt Generator',
      description: 'Create an AI-powered tool that generates optimized prompts based on user input. The tool should: Take a brief user input describing their goal, topic, or task. Use AI to structure and enhance the input into a well-defined prompt. Support different prompt styles (e.g., creative, technical, detailed, concise). Allow customization for tone, length, and complexity',
      type: 'AI',
    },
  
  ];